/* eslint-disable */
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { TaskState } from './state';

const defaultState: TaskState = {
  taskList: {
    count: 0,
    next: '',
    previous: '',
    results: [
    ]
  },
  recordProject: {
    project: 0,
  },
  scriptList: {
    count: 0,
    next: '',
    previous: '',
    results: [
    ]
  },
  simpleScriptList: [],
  pipelineList: [],
  pipelinePkgList: [],
  TaskStatus: [],
  TaskStats: [],
  PerformanceVersions:[],
  TestData: {
    title: {
      text: "ECharts 入门示例",
    },
    tooltip: {},
    xAxis: {
      data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"],
    },
    yAxis: {},
    series: [
      {
        name: "销量",
        type: "bar",
        data: [5, 20, 36, 10, 10, 20],
      },
    ],
  },
  taskRecords: [],
  taskSimpleRecords: {
    count: 0,
    next: "",
    previous: "",
    results: [],
  },
  taskRecord: null,
  accountList: [],
  taskGroup: {
    DeviceTaskPhase: {
      Start: "start",
      // # 设备收到任务
      Download: "download",
      // # 完成下载
      Login: "login",
      // # 完成登录
      EnterScene: "enter_scene",
      // # 进入场景
      InScene: "in_scene",
      // # 场景中
      Finish: "finish",
      // # 完成
    },

    PhaseStatus: {
      Wait: "wait",
      // # 初始为wait（后台判定）
      Running: "running",
      // # 阶段进行中（后台判定）
      Done: "done",
      // # 完成阶段（app上报）
      Error: "error",
      // # 出现异常（app上报）
    },

    task_group: [
      {
        // # 任务1
        name: "",
        // # 循环次数，作用于该任务下的所有设备
        cycle_count: 3,
        // # 剩余循环次数，完成一次后-1
        rest_cycle_count: 3,
        // # 任务组的状态只有四种，Idle=0:初始状态，Running=1:进行中，Error=5:异常，Finished=3:完成
        status: 0,
        // # 设备组
        device_group: {
          // # 设备1
          // # 设备id，关联device_info表
          1: {
            // # 执行阶段，通过app上报来更新
            phase: {
              "DeviceTaskPhase.Start": {
                status: "",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Download": {
                status: "1",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Login": {
                status: "5",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.EnterScene": {
                status: "3",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.InScene": {
                status: "1",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Finish": {
                status: "3",
                complete_time: "",
                msg: "",
              },
            },
          },
          2: {
            // # 执行阶段
            phase: {
              "DeviceTaskPhase.Start": {
                status: "1",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Download": {
                status: "3",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Login": {
                status: "5",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.EnterScene": {
                status: "0",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.InScene": {
                status: "0",
                complete_time: "",
                msg: "",
              },
              "DeviceTaskPhase.Finish": {
                status: "",
                complete_time: "",
                msg: "",
              },
            },
          },
        },
      },
    ],
    // # 报告模块
    report: {
      send_report: true,
      send_notify: true,
    },
    taskInfo: {
      id: 10,
      task_name: "",
      status: 4,
      status_detail: "",
      start_date: "",
      end_date: "",
      task: 9,
      project: 1,
      create_user: "",
    },
  },
  downloadPkg:{},
  pipe_line:{}
};


export const taskModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};


export const TaskContent: any = {
  global_settings: {
    trigger: {
      // # 任务的触发类型，枚举定义utils.common_define.TriggerType, 包含手动、自动检测流水线是否有最新构建、以及定时器
      type: '',
      // # 当type为定时器的时候才需读取该值，定时器的具体设计后续再细化
      value: ''
    },
    // # 下载器
    downloader: {
      // # 配置的流水线表（超哥负责）的id，可索引到下载所需的蓝盾流水线id、key等信息，如为空则不自动下载安装（需手动提前在设备上安装）
      pipeline: '',
      // # 蓝盾构建号，如果为None或空，则取最新构建
      build_id: '',
    },
    // # 登录器
    login: {
      // # 枚举定义utils.common_define.ControllerType，包含手动登录、硬编码(接口)登陆、图像识别录制登陆
      type: '',
      // # 当type为图像识别的时候，value为图像识别脚本id
      value: '',
    },
    // # 启动条件
    conditions: {
      // # 条件类型，枚举定义utils.common_define.ConditionType, 包含重启手机、重启游戏、等待等，如果为循环多次任务的时候，每次循环开始前都会执行
      type: '',
      // # 当type为wait的时候该值为等待的秒数
      value: ''
    },
    // # 采集器
    collector: {
      // # 采集器类型，枚举定义utils.common_define.CollectorType，暂只支持客户端性能采集
      type: '',
      // # 保留字段，待定
      value: ''
    },
  },
  // # 任务组，任务组下的每个任务依次（串行）下发执行
  task_group: [
    {
      // # 任务1
      name: '',
      // # 启动条件，作用于该任务下的所有设备，如果在全局设置里配置了，则前端下发时直接使用全局设置
      conditions: {
        // # 条件类型，枚举定义utils.common_define.ConditionType, 包含重启手机、重启游戏、等待等，如果为循环多次任务的时候，每次循环开始前都会执行
        type: '',
        // # 当type为wait的时候该值为等待的秒数
        value: ''
      },
      // # 循环次数，作用于该任务下的所有设备
      cycle_count: '',
      // # 设备组，设备组下的多个设备任务同时下发，如需串行执行，则要配置多个任务组
      device_group: {
        // # 设备1
        // # 设备id，关联device_info表
        1: {
          id: '',
          // # 为接口登陆或图像识别登陆时，需配置使用的账号，关联账号account表
          account: '',
          // # 进入场景方式
          enter_scene: {
            // # 与登录器一样，枚举定义utils.common_define.ControllerType
            type: '',
            // # 当type为图像识别的时候，value为图像识别脚本id，当type为接口时，value为接口所需的参数，一般是map id
            value: ''
          },
          // # 脚本id
          script: '',
          // # 禁止行为列表，如禁止播放脚本中的开火、跳跃等
          act_prohibit: [],
          custom_json:""

        },
      },
    },
  ],
  // # 报告模块
  report: {
    // # True or False, 是否发送报告
    send_report: true,
    // # 使用的报告模板id，索引配置的收件人、标题等信息
    report_template: '',
    // # True or False, 是否发送通知
    send_notify: true,
    // # 通知类型，数组，可同时配置多组通知
    notify_type: [
      {
        // # 通知类型，数组，可发多类通知，使用枚举定义utils.common_define.NotifyType
        type: '',
        // # 根据类型分别为企业微信的通知账号id、机器人id等
        value: ''
      },
      {
        type: '',
        value: ['',]
      }
    ],
  }
}
